export enum NodeEnvironmentType {
  Local = 'local-development',
  Development = 'development',
  Beta = 'beta',
  OnPrem = 'on-prem',
  Production = 'production',
  Staging = 'staging',
  Test = 'test',
}
